var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentRecords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6725 0C5.11048 0 3.82812 1.27097 3.82812 2.82781C3.82812 4.38478 5.11062 5.65561 6.6725 5.65561C8.24334 5.65561 9.52799 4.38464 9.52799 2.82781C9.52799 1.27083 8.24348 0 6.6725 0Z",
    fill: "#DBDFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6743 8.50879C8.03128 8.50879 9.38787 8.70757 10.5101 9.09794V9.09807H10.5105C11.3876 9.40268 12.1177 9.82098 12.6074 10.3157C13.097 10.8104 13.3568 11.3591 13.3568 12.0393V13.1252H0V12.0393C0 11.2597 0.338128 10.6453 0.970819 10.1055C1.60338 9.56578 2.53717 9.13687 3.6179 8.86444C4.5635 8.62604 5.6191 8.50813 6.67447 8.50896L6.6743 8.50879Z",
    fill: "#DBDFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4948 8.51453C15.5333 8.52688 16.566 8.65415 17.488 8.89704C18.5417 9.17465 19.4474 9.60234 20.0601 10.1358C20.6727 10.6693 20.9998 11.2741 20.9998 12.0391V13.125H14.4064V12.0391C14.4064 11.0744 13.9979 10.228 13.3536 9.57695C13.0138 9.23366 12.611 8.9391 12.1621 8.68671C12.9127 8.56378 13.7048 8.50517 14.4947 8.51467L14.4948 8.51453Z",
    fill: "#DBDFF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3275 0C12.7655 0 11.4834 1.27097 11.4834 2.82781C11.4834 4.38478 12.7656 5.65561 14.3275 5.65561C15.8895 5.65561 17.1716 4.38464 17.1716 2.82781C17.1716 1.27083 15.8894 0 14.3275 0Z",
    fill: "#DBDFF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentRecords);
export default __webpack_public_path__ + "static/media/studentRecords.52766b12db1b9eac519165111f35ae62.svg";
export { ForwardRef as ReactComponent };